"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BadLocationError = _interopRequireDefault(require("../ErrorClasses/BadLocationError"));
var _LocationType = _interopRequireDefault(require("./LocationType"));
var _misc = _interopRequireDefault(require("./misc"));
var MapProcessingUtil = _interopRequireWildcard(require("../MapProcessingUtil"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// TODO: We should only try to pull DCVG data if surveyType=DCVG
const _extractGpsReadingData = flattenedGpsReading => {
  const {
    code,
    readingReplaced,
    StationId,
    time,
    comments,
    locationType,
    coordinates,
    prevDistance,
    prevGap,
    prevAzimuth,
    nextDistance,
    nextGap,
    nextAzimuth,
    oldStns,
    // ON-OFF
    reading1,
    reading2,
    originalReading1,
    originalReading2,
    // DCVG
    ir,
    doc,
    ss,
    flaggedSS,
    flaggedStn,
    olre,
    clock,
    // eslint-disable-next-line camelcase
    prev_coordinate_before_move,
    // eslint-disable-next-line camelcase
    next_coordinate_before_move,
    interpolatedReading1,
    interpolatedReading2,
    acOn,
    acOff,
    gpsType,
    triggerType,
    docTop,
    fileName,
    originalComments,
    ...otherProps
  } = flattenedGpsReading;
  const reading = {
    code,
    value: {
      time,
      comments,
      StationId,
      readingReplaced,
      oldStns,
      // ON-OFF
      reading1,
      reading2,
      originalReading1,
      originalReading2,
      // DCVG
      ir,
      doc,
      ss,
      flaggedSS,
      flaggedStn,
      olre,
      clock,
      interpolatedReading1,
      interpolatedReading2,
      acOn,
      acOff,
      gpsType,
      triggerType,
      docTop,
      fileName,
      originalComments
    }
  };
  _misc.default.validateEmptyProps('flattened gpsreading', otherProps);
  switch (locationType) {
    case _LocationType.default.INTERPOLATED:
      return {
        reading
      };
    case _LocationType.default.GPS:
      return {
        coordinates,
        nextDistance,
        nextGap,
        nextAzimuth,
        prevDistance,
        prevGap,
        prevAzimuth,
        readings: [reading]
      };
    default:
      throw new _BadLocationError.default(`Unknown location type ${locationType}`);
  }
};
const removeEmptyValuesFromEntireTree = gpsReadings => {
  gpsReadings.forEach(gpsReading => {
    _misc.default.cleanEmptyValues(gpsReading);
    gpsReading.readings.forEach(reading => {
      const {
        value
      } = reading;
      _misc.default.cleanEmptyValues(reading);
      _misc.default.cleanEmptyValues(value);
    });
  });
};
const cleanEntireTree = gpsReadings => {
  removeEmptyValuesFromEntireTree(gpsReadings);
  MapProcessingUtil.updateGPSMeasurements(gpsReadings);
};
const nestGpsReadings = flattenedGpsReadings => {
  const [{
    code,
    locationType
  } = {}] = flattenedGpsReadings;
  // check to see if data already nested

  if (flattenedGpsReadings.length > 0 && code === undefined && locationType === undefined) {
    return flattenedGpsReadings;
  }
  const nestedGpsReadings = [];
  let currentNestedGpsReading = null;
  flattenedGpsReadings.forEach(flattenedGpsReading => {
    const {
      locationType
    } = flattenedGpsReading;
    switch (locationType) {
      case _LocationType.default.GPS:
        {
          if (currentNestedGpsReading) {
            nestedGpsReadings.push(currentNestedGpsReading);
          }
          currentNestedGpsReading = _extractGpsReadingData(flattenedGpsReading);
          break;
        }
      case _LocationType.default.INTERPOLATED:
        {
          const {
            reading
          } = _extractGpsReadingData(flattenedGpsReading);
          currentNestedGpsReading.readings.push(reading);
          break;
        }
      default:
        throw new _BadLocationError.default(`Unkown location type ${locationType}`);
    }
  });
  if (currentNestedGpsReading) {
    nestedGpsReadings.push(currentNestedGpsReading);
  }
  cleanEntireTree(nestedGpsReadings);
  return nestedGpsReadings;
};
var _default = nestGpsReadings;
exports.default = _default;